$('.search-music-wrapper').delegate('.sku', 'click', async function (e) {
  e.preventDefault();

  await navigator.clipboard.writeText($(this).data('sku'));

  toastr.success(__('SKU Copied to clipboard'));
});
